import React, { useState, useRef, useEffect } from "react";
import { Carousel, Container, Row, Col } from "react-bootstrap";
import "./HomeCarousel.css";

function HomeCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const videoRef = useRef(null);

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  useEffect(() => {
    const videoElement = videoRef.current;

    const handleMouseEnter = () => {
      videoElement.play();
      videoElement.muted = false;
    };

    const handleMouseLeave = () => {
      videoElement.pause();
      videoElement.muted = true;
    };

    videoElement.addEventListener("mouseenter", handleMouseEnter);
    videoElement.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      videoElement.removeEventListener("mouseenter", handleMouseEnter);
      videoElement.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <Container fluid className="carousel-container">
      <Carousel
        activeIndex={activeIndex}
        onSelect={handleSelect}
        interval={null}
        indicators={true}
        fade
        prevIcon={
          <span
            data-testid="carousel-prev-icon"
            className={`carousel-control-prev-icon ${activeIndex === 0 ? "d-none" : ""}`}
          />
        }
        prevLabel=""
        className={activeIndex === 0 ? "hide-prev" : ""}
        nextIcon={
          <span
            data-testid="carousel-next-icon"
            className="carousel-control-next-icon"
          />
        }
      >
        <Carousel.Item>
          <Row className="align-items-center flex-column flex-md-row">
            <Col xs={12} md={6} className="p-4 text-center text-md-start">
              <div
                xs={2}
                md={3}
                lg={4}
                xl={6}
                xxl={7}
                className="text-container"
              >
                <div className="launch-aca">Launch Academy</div>
                <p className="launch-bold">
                  Launch <br /> is for the <br />
                  <span className="bold-css boldd">Bold</span>
                </p>
                <p className="video-para">
                  Join us and create digital <br /> experiences that move
                  millions
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-center">
              <video
                data-testid="carousel-video"
                ref={videoRef}
                className="media-video"
                src="./HomePageImages/FinalLaunchVideo.mp4"
                controls
                muted
                loop
              />
            </Col>
          </Row>
        </Carousel.Item>
        <Carousel.Item>
          <Row className="align-items-center flex-column flex-md-row">
            <Col xs={12} md={6} className="p-4 text-center text-md-start">
              <div
                xs={2}
                md={3}
                lg={4}
                xl={6}
                xxl={7}
                className="text-container"
              >
                <div className="launch-aca">Launch Academy</div>
                <h2 className="learn-earn">
                  Learn & <br />
                  <span className="earn-css">Earn</span>
                  <p className="belaunchified">be Launchified.</p>
                </h2>
                <p className="paraMission">
                  <strong>Mission:</strong> We exist to help you strategize,
                  ship, and scale provocative digital experiences that connect
                  with your customers and drive growth.
                </p>
              </div>
            </Col>
            <Col xs={12} md={6} className="d-flex justify-content-center">
              <img src="4pillar.png" alt="pillar" className="image-pillar" />
            </Col>
          </Row>
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}

export default HomeCarousel;
